<template>
  <div>
    <a-layout>
      <c-page-header :title="title" :subTitle="subTitle" :userInfo="userInfo"/>
      <a-layout>
        <c-page-menus :menus="menus"/>
        <a-layout-content class="content">
          <keep-alive>
            <router-view name="innerView"></router-view>
          </keep-alive>
        </a-layout-content>
      </a-layout>
      <c-page-footer/>
    </a-layout>
    <div class="dialog" v-if="show.dialog" style="z-index: 10;">
	    <div class="dialog-body">
			<p>若使用浏览器进行财政公示失败，请下载并尝试客户端模式进行财政公示。</p>
	    </div>
	    <div class="dialog-foot">
	    	<button @click="downLoadExe" class="dialog-button">下载</button>
	    	&nbsp;&nbsp;&nbsp;
	        <button @click="closeDialog" class="dialog-button">关闭</button>
	    </div>
	</div>
  </div>
</template>

<script>
import CPageHeader from "@/views/component/C-PageHeader";
import CPageMenus from "@/views/component/C-PageMenus";
import CPageFooter from "@/views/component/C-PageFooter";
import {getToken, getUserInfo} from "@/utils/sessionUtils";
import {$addRouters} from "@/router";

export default {
  name: "Index",
  components: {
    CPageHeader,
    CPageMenus,
    CPageFooter,
  },
  data() {
    return {
    	show: {
        	dialog: true,
      	},
      title: '钟山区财政预决算公示平台',
      subTitle: '公示业务管理台',
      userInfo: {},
      menus: [],
      options: {
        //超级管理员
        menus1: [
          {
            key: '30',
            name: '公示概况',
            icon: 'setting',
            path: '/manage/publish-view',
          },
          {
            key: '9',
            name: '公示审核',
            icon: 'file',
            path: '/manage/publish-audit',
          },
          {
            key: '10',
            name: '财政公示',
            icon: 'file',
            path: '/manage/publish-list',
          },
          {
            key: '20',
            name: '部门管理',
            icon: 'wallet',
            path: '/manage/govern-list',
          },
          {
            key: '991',
            name: '用户管理',
            icon: 'usergroup-add',
            path: '/manage/users-list',
          },
          {
            key: '992',
            name: '系统设置',
            icon: 'setting',
            path: '/manage/settings',
          },
        ],
        //教育局审核用户
        menus2: [
          {
            key: '9',
            name: '公示审核',
            icon: 'file',
            path: '/manage/publish-audit-jyj',
          },
          {
            key: '10',
            name: '财政公示',
            icon: 'file',
            path: '/manage/publish-list',
          },
        ],
        //单位用户
        menus3: [
          {
            key: '10',
            name: '财政公示',
            icon: 'file',
            path: '/manage/publish-list',
          },
        ],
        roles: [
          {name: '超级管理员', menus: 'menus1', routerMap: 'routerMap1'},
          {name: '区本级审核用户', menus: 'menus1', routerMap: 'routerMap1'},
          {name: '教育局审核用户', menus: 'menus2', routerMap: 'routerMap2'},
          {name: '单位用户', menus: 'menus3', routerMap: 'routerMap3'},
        ]
      },
      demo: {
        routerMap: [
          {
            path: '/manage/user-list',
            name: 'sys-user-list',
            filePath: 'manage/UserList',
          },
          {
            path: '/manage/roles-list',
            name: 'sys-roles-list',
            filePath: 'manage/RolesList',
          },
          {
            path: '/manage/menus-list',
            name: 'sys-menus-list',
            filePath: 'manage/MenusList',
          },
        ],
        menus: [
          {
            key: '9',
            name: '公示审核',
            icon: 'file',
            path: '/manage/publish-audit',
          },
          {
            key: '10',
            name: '财政公示',
            icon: 'file',
            path: '/manage/publish-list',
          },
          {
            key: '20',
            name: '部门管理',
            icon: 'wallet',
            path: '/manage/govern-list',
          },
          {
            key: '30',
            name: '公示概况',
            icon: 'setting',
            path: '/manage/publish-view',
          },
          {
            key: '991',
            name: '用户管理',
            icon: 'usergroup-add',
            path: '/manage/users-list',
          },
          {
            key: '995',
            name: '预览4-正常xlsx',
            icon: 'usergroup-add',
            path: '/manage/view4',
          },
        ],
      },
    };
  },
  activated() {
    this.checkLoginStatus()
    this.initMenus()
  },
  created() {
  },
  mounted() {
  },
  methods: {
    checkLoginStatus() {
      let token = getToken()
      let userInfo = getUserInfo()
      this.$store.state.token = token
      this.$store.state.userInfo = userInfo
      if (!!(token && userInfo)) {
        this.userInfo = userInfo
        // this.$router.push('/manage/welcome')
      } else {
        this.$router.push('/login')
      }
    },
    initRouter() {
      this.options.roles.forEach(e => {
        if (this.userInfo.role === e.name) {
          this.routerMap = this.options[e.routerMap]
          console.log(this.routerMap)
        }
      })
      console.log('初始化路由')
      $addRouters(this.routerMap)
    },
    initMenus() {
      this.options.roles.forEach(e => {
        if (this.userInfo.role === e.name) {
          this.menus = this.options[e.menus]
          console.log(this.userInfo.role)
        }
      })
    },
    closeDialog() {
        this.show.dialog = false;
    },
    downLoadExe(){
    	window.open('http://58.42.212.233:8088/download/lps_zsq_yjs_system.rar');
    }
  }
}
</script>

<style scoped lang="less">
@import "~@public/color.less";

.title {
  font-size: 20px;
  color: #fff;
  font-weight: 700;
}

.subTitle {
  font-size: 18px;
  color: #fff;
  font-weight: 500;
}

.ant-layout-header {
  background: @primary-color;
  color: #fff;
  height: 7vh;
  line-height: 7vh;
}

.ant-layout-footer {
  background: @primary-color;
  color: #fff;
  height: 10vh;
  line-height: 7vh;
}

.ant-layout-sider {
  width: 100%;
  height: 83vh;
  background: #fff;
}

.ant-layout-content {
  box-shadow: inset 0 0 5px fade(@primary-color, 20%);
  padding: 12px;
  background: #fff;
  min-height: 120px;
  height: 83vh;
  overflow: auto;
}

/*滚动条整体样式*/
.ant-layout-content::-webkit-scrollbar {
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  margin-right: 10px;
  opacity: 0.2;
}

/*滚动条里面小方块(滑块 )*/
.ant-layout-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}

/*滚动条里面轨道(背景)*/
.ant-layout-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  border-radius: 10px;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}
.dialog {
    width: 230px;
    height: 200px;
    background: #b5e2e6c7;
    position: fixed;
    top: 30vh;
    right: 5px;
    border-radius: 15px;
}

.dialog-body {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    height: 130px;
    width: 100%;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    font-size: 18px;
    color: #c6121d;
    padding: 0px 5px;
}
.dialog-body p{
	text-indent: 2em;
}

.dialog-foot {
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    height: 50px;
    width: 100%;
    text-align: right;
}

.dialog-button {
	width: 72px;
    height: 30px;
}
</style>
